import { config } from '@abyss/ui/tools/config';

import appConfig from './app.json';
import localConfig from './env/local.json';
import testConfig from './env/test.json';
import stageConfig from './env/stage.json';
import oscarConfig from './env/oscar.json';
import prodConfig from './env/prod.json';
import devConfig from './env/dev.json';
import papaConfig from './env/papa.json';
import quebecConfig from './env/quebec.json';

const envs = {
  local: localConfig,
  test: testConfig,
  stage: stageConfig,
  oscar: oscarConfig,
  papa: papaConfig,
  quebec: quebecConfig,
  prod: prodConfig,
  dev: devConfig,
};

config({ ...appConfig, ...envs[config('APP_ENV')] });
